const PUBLIC_SHELL_EXACT = new Set([
  "/login",
  "/password-reset",
  "/terms-of-use",
  "/privacy-policy",
  "/select-account-type",
  "/create-account",
  "/email-verification",
  "/error",
]);

const UPLOAD_SHELL_PREFIX = "/upload/";
const NPO_ENROLLMENT_PREFIX = "/npo-enrollment";
const CALCULATOR_PREFIX = "/calculators";

export function isUploadShellPath(pathname) {
  return typeof pathname === "string" && pathname.startsWith(UPLOAD_SHELL_PREFIX);
}

export function isNpoEnrollmentPath(pathname) {
  return typeof pathname === "string" && pathname.startsWith(NPO_ENROLLMENT_PREFIX);
}

export function isCalculatorPath(pathname) {
  return (
    typeof pathname === "string" &&
    (pathname === CALCULATOR_PREFIX || pathname.startsWith(`${CALCULATOR_PREFIX}/`))
  );
}

/** True for logged-out / alternate-auth shells that must not force portal logout. */
export function isPublicShellPath(pathname) {
  if (!pathname) return false;
  if (PUBLIC_SHELL_EXACT.has(pathname)) return true;
  return isUploadShellPath(pathname) || isNpoEnrollmentPath(pathname) || isCalculatorPath(pathname);
}
